// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3cR_Z","info":"PatientInfo_info__1z4OM"};